import { makeStyles } from "@mui/styles";
import React from "react";
import Heading from "./Heading";

const useStyles = makeStyles({
  hero: {
    position: "relative",
    display: "flex",
    height: "100vh",
    width: "100%",
    zIndex: "999",
  },

  canvas: {
    position: "absolute",
    top: "0",
    right: "0",
    left: "0",
    bottom: "0",
    width: "100%",
    height: "100vh",
    backgroundColor: "#1a1a1a",
    overflow: "hidden",
  },

  connectingDots: {
    height: "100%",
    width: "100%",
  },
  mainBg: {
    height: "100vh",
    position: "fixed",
    top: "0",
    width: "100%",
    backgroundColor: "royalblue",
  },
});

function Particles() {
  const classes = useStyles();
  return (
    <>
      <div className={classes.hero} id="hero">
        <div className={classes.canvas}>
          <canvas className={classes.connectingDots}></canvas>
        </div>
        {/* Here home page's HEADING message */}
        <Heading />
      </div>

      <div className={classes.mainBg}>
        <div className={classes.canvas}>
          <canvas className="canvas-2"></canvas>
        </div>
      </div>
    </>
  );
}

export default Particles;
